import React from 'react';

import { Box } from '@chakra-ui/react';

import { MeshMavenDisabledThumbsUp } from 'assets/assetsV1/iconComponents/MeshMavenDisabledThumbsUp';
import { MeshMavenWithThumbsUp } from 'assets/assetsV1/iconComponents/MeshMavenWithThumbsUp';

import { Button } from 'uiToolkitV1/Button';

import './MavenButton.css';

const MavenButton = React.forwardRef(
  ({ text = 'Help me write', isDisabled = false, onClick = () => {}, buttonProps = {}, icon = null, ...rest }, ref) => (
    <Box p="1px" ref={ref} {...rest}>
      <Button
        StartIcon={icon || (isDisabled ? MeshMavenDisabledThumbsUp : MeshMavenWithThumbsUp)}
        startIconProps={{ padding: '4px', opacity: '1', position: 'absolute', left: '-25px', top: '0px' }}
        className={`maven-button ${isDisabled ? 'disabled' : ''}`}
        variant="tertiary"
        isDisabled={isDisabled}
        padding="8px 16px 8px 24px"
        height="40px"
        iconSize="48px"
        data-text={text}
        onClick={onClick}
        {...buttonProps}
      />
    </Box>
  )
);

export default MavenButton;
